import { z } from "zod";

export const loginValidation = z.object({
  email: z.string().email("Email tidak valid"),
  password: z.string().min(6, "Password minimal 6 karakter"),
});

export type LoginPayload = z.infer<typeof loginValidation>;

export const registerFormSchema = z
  .object({
    poktanId: z
      .union([z.number(), z.string()])
      .transform((val) => {
        const numberValue = Number(val);
        return isNaN(numberValue) ? val : numberValue;
      })
      .refine((val) => val !== "" && val !== undefined && val !== null, {
        message: "Poktan wajib dipilih",
      }),

    memberRole: z.string().min(1, "Jabatan wajib diisi"),
    instansiId: z
      .union([z.number(), z.string()])
      .transform((val) => {
        const numberValue = Number(val);
        return isNaN(numberValue) ? val : numberValue;
      })
      .optional(),

    name: z.string().min(1, "Nama wajib diisi"),
    email: z.string().email("Email tidak valid").min(1, "Email wajib diisi"),
    password: z.string().min(6, "Kata sandi minimal 6 karakter"),
    confirmPassword: z.string().min(6, "Konfirmasi kata sandi wajib diisi"),

    gender: z.string().min(1, "Jenis kelamin wajib diisi"),
    nik: z.string().length(16, "NIK harus 16 digit"),
    phone: z.string().min(10, "Nomor HP minimal 10 digit"),

    villageCode: z.string().min(1, "Desa wajib diisi"),
    districtCode: z.string().min(1, "Kecamatan wajib diisi"),
    regencyCode: z.string().min(1, "Kabupaten wajib diisi"),
    provinceCode: z.string().min(1, "Provinsi wajib diisi"),
    pengaju: z.any(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Konfirmasi password tidak sama",
    path: ["confirmPassword"],
  });

export type RegisterPayload = z.infer<typeof registerFormSchema>;

export const forgoutPasswordValidation = z.object({
  email: z.string().email("Email tidak valid"),
});

export type ForgoutPasswordPayload = z.infer<typeof forgoutPasswordValidation>;

export const resetPasswordValidation = z.object({
  newPassword: z.string(),
  confirmPassword: z.string(),
});

export type ResetPasswordPayload = z.infer<typeof resetPasswordValidation>;
